import getDateSortTimeStampFromRowData from './getDateSortTimeStampFromRowData';
import tombstoneOperations from 'owa-mail-list-tombstone';
/**
 * Returns true if the the given row from FindConversationResponse or FindItemResponse should be skipped, false if it should be processed
 * @param row to be processed
 * @param tableView to process the conversation in
 */
export default function shouldSkipProcessRow(row, tableView) {
    var timeStamp = getDateSortTimeStampFromRowData(row, tableView.tableQuery.listViewType);
    // Do not process the conversation if it was earlier than the lastEmptiedTime in case we did an empty folder in this tableView
    if (tableView.lastEmptiedTime &&
        tableView.lastEmptiedTime > new Date(timeStamp.lastDeliveryTimeStamp)) {
        return true;
    }
    // Do not process the row if it's tombstoned pending delete
    var removeFromTombstoneCondition = tombstoneOperations.contains(row.InstanceKey, tableView.serverFolderId);
    if (removeFromTombstoneCondition &&
        removeFromTombstoneCondition.type === 0 /* OnDeleteNotification */) {
        return true;
    }
    return false;
}
//# sourceMappingURL=shouldSkipProcessRow.js.map